import { Text } from '@wix/design-system';
import { symbol as Symbol } from '@wix/santa-editor-symbols';
import React, { type FC } from 'react';
import styles from './AssistantMessage.module.scss';

interface AssistantMessageProps {
  text?: string;
}

export const AssistantMessage: FC<AssistantMessageProps> = ({
  text,
  children,
}) => {
  return (
    <div className={styles.assistantMessage__wrapper}>
      <div className={styles.assistantMessage__icon}>
        <Symbol name="aiTextCreatorV2AiIcon" />
      </div>
      <div className={styles.assistantMessage}>
        {text && (
          <div className={styles.assistantMessage__item}>
            <Text size="small">{text}</Text>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
